import { v4 as uuidv4 } from 'uuid'

const data = [
  {
    id: uuidv4(),
    desc: `Guaranteeing prompt delivery backed up with over 110 completed deliveries with as many satisfied customers.`,
    fullName: 'Innocent Moses',
    twitter: `https://twitter.com/AmgelInnocent`,
  },
  {
    id: uuidv4(),
    desc: `Very efficient, prompt and reliable.`,
    fullName: 'Thomas Sankara',
    twitter: `https://twitter.com/TSBSankara`,
  },
]

export default data
